import React, {useEffect, useState} from 'react';
import {defaultErrorHandler} from '../../context/context';
import notificationV1Client from '../../infrastructure/acerill/notification-v1-client';
import fieldService from '../../services/field-service';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import SelectField from '../../libs/react-components-admin/fields/select-field';

const InsertField = ({label, fields, onClick}) => {

  const [selectedFieldId, setSelectedFieldId] = useState(fields && fields.length > 0 ? fields[0].id : null);

  return <>
    {label}<div className="d-inline-block px-3"
                style={{minWidth: '120px', maxWidth: '200px'}}>
      <SelectField values={fields.map(f => ({
                     label: fieldService.fieldDescription(f),
                     value: f.id,
                   }))}
                   value={selectedFieldId}
                   onChange={v => setSelectedFieldId(v)}/>
    </div>
    <button type="button"
            className="d-inline-block btn btn-secondary btn-sm px-4"
            onClick={() => onClick(selectedFieldId)}
            disabled={!selectedFieldId}>
      Insert
    </button>
  </>
};

const Template = ({rowCount, id, sampleTemplate, fields, onChange}) => {

  let caretListenersAdded = false;
  let caretIndex = 0;

  const [content, setContent] = useState();

  useEffect(() => { onChange(content); }, [content]);

  useEffect(() => {
    notificationV1Client.findTemplateById(id)
      .then(template => {
        if (!template) {
          setContent('');
        } else {
          setContent(template.content);
        }
      })
      .catch(err => defaultErrorHandler(err));
  }, [id]);

  const addCaretListeners = textArea => {
    if (!textArea || caretListenersAdded) {
      return;
    }
    caretListenersAdded = true;
    // See https://stackoverflow.com/questions/53999384/javascript-execute-when-textarea-caret-is-moved
    const updateCaret = () => {
      caretIndex = textArea.selectionStart;
    };
    textArea.addEventListener('keypress', updateCaret);
    textArea.addEventListener('keyup', updateCaret);
    textArea.addEventListener('mousedown', updateCaret);
    textArea.addEventListener('touchstart', updateCaret);
    textArea.addEventListener('input', updateCaret);
    textArea.addEventListener('paste', updateCaret);
    textArea.addEventListener('cut', updateCaret);
    textArea.addEventListener('mousemove', updateCaret);
    textArea.addEventListener('select', updateCaret);
    textArea.addEventListener('selectstart', updateCaret);
  };

  const insertFieldValue = fieldId => {
    const sanitizedCaret = Math.max(0, Math.min(content.length, caretIndex));
    setContent((sanitizedCaret > 0 ? content.substring(0, sanitizedCaret) : '') +
      '{{fields.' + fieldId + '.value}}' +
      (sanitizedCaret < content.length ? content.substring(sanitizedCaret, content.length) : '')
    );
  };

  if (content == null) {
    return <CenteredSpinner/>;
  }
  return <div className="row justify-content-end">
    <div className="col-12">
      <div className="mb-3">
        <textarea ref={node => addCaretListeners(node)}
                  className="form-control"
                  id={id}
                  value={content || ''}
                  onChange={e => setContent(e.target.value)}
                  rows={rowCount}/>
      </div>
    </div>
    <div className="w-100"/>
    {fields && fields.length > 0 &&
    <div className="col-auto">
      <InsertField label="Insert field value:"
                   fields={fields}
                   onClick={fieldId => insertFieldValue(fieldId)}/>
    </div>
    }
    {sampleTemplate && <>
      <div className="w-100"/>
      <div className="col-auto mb-3">
        <button type="button" className="btn btn-secondary btn-sm px-4"
                onClick={() => setContent(sampleTemplate)}>
          Populate with sample template
        </button>
      </div>
    </>}
  </div>;

};

export default Template;
